/* eslint-disable max-len */
const KEYSTREAM_ACTIVATED = 'ACTIVATED';
const VEHICLE_PAIRED_TO = {
  TAG: 'tag',
  LOCATOR: 'locator',
  TAG_AND_LOCATOR: 'tagAndLocator'
};
const SALE_NAMES = {
  VEHICLE_WITH_LOCATOR: 'RecovR',
  VEHICLE_ONLY: 'Vehicle Only',
  VEHICLE_WHOLESALE: 'Vehicle Wholesale',
  DEALER_TRADE: 'Dealer Trade'
};
const SALE_TYPES = {
  VEHICLE_WITH_LOCATOR: 'vehicle-with-locator',
  VEHICLE_ONLY: 'vehicle-only',
  LOCATOR_ONLY: 'locator-only',
  VEHICLE_WHOLESALE: 'vehicle-wholesale',
  DEALER_TRADE: 'dealer-trade'
};
const SALE_TYPE_NAMES = {
  'dealer-trade': 'Dealer Trade',
  'vehicle-only': 'Vehicle Sale',
  'vehicle-wholesale': 'Vehicle Wholesale',
  'vehicle-with-locator': 'RecovR Sale'
};
const VEHICLE_SALE_STATES = {
  AVAILABLE: 'available',
  PENDING: 'pendingRemoveLocator',
  PENDING_REMOVE_LOCATOR: 'pendingRemoveLocator',
  PENDING_REPLACE_LOCATOR: 'pendingReplaceLocator',
  PENDING_ADD_LOCATOR: 'pendingAddLocator',
  SOLD: 'sold'
};
const COUNTRIES = [{
  name: 'Canada',
  addressRegexPattern: /\b(Canada|CANADA)\b/gi,
  states: [{
    name: 'Alberta',
    value: 'AB',
    addressRegexPattern: /\b(Alberta|AB)\b/gi
  }, {
    name: 'British Columbia',
    value: 'BC',
    addressRegexPattern: /\b(British Columbia|BC)\b/gi
  }, {
    name: 'Manitoba',
    value: 'MB',
    addressRegexPattern: /\b(Manitoba|MB)\b/gi
  }, {
    name: 'New Brunswick',
    value: 'NB',
    addressRegexPattern: /\b(New Brunswick|NB)\b/gi
  }, {
    name: 'Newfoundland and Labrador',
    value: 'NL',
    addressRegexPattern: /\b(Newfoundland and Labrador|NL)\b/gi
  }, {
    name: 'Northwest Territories',
    value: 'NT',
    addressRegexPattern: /\b(Northwest Territories|NT)\b/gi
  }, {
    name: 'Nova Scotia',
    value: 'NS',
    addressRegexPattern: /\b(Nova Scotia|NS)\b/gi
  }, {
    name: 'Nunavut',
    value: 'NU',
    addressRegexPattern: /\b(Nunavut|NU)\b/gi
  }, {
    name: 'Ontario',
    value: 'ON',
    addressRegexPattern: /\b(Ontario|ON)\b/gi
  }, {
    name: 'Prince Edward Island',
    value: 'PE',
    addressRegexPattern: /\b(Prince Edward Island|PE)\b/gi
  }, {
    name: 'Quebec',
    value: 'QC',
    addressRegexPattern: /\b(Quebec|QC)\b/gi
  }, {
    name: 'Saskatchewan',
    value: 'SK',
    addressRegexPattern: /\b(Saskatchewan|SK)\b/gi
  }, {
    name: 'Yukon',
    value: 'YT',
    addressRegexPattern: /\b(Yukon|YT)\b/gi
  }]
}, {
  name: 'USA',
  addressRegexPattern: /\b(US|USA|United States|UNITED STATES|United States of America)\b/gi,
  states: [{
    name: 'Alabama',
    value: 'AL',
    addressRegexPattern: /\b(Alabama|AL)\b/gi
  }, {
    name: 'Alaska',
    value: 'AK',
    addressRegexPattern: /\b(Alaska|AK)\b/gi
  }, {
    name: 'Arizona',
    value: 'AZ',
    addressRegexPattern: /\b(Arizona|AZ)\b/gi
  }, {
    name: 'Arkansas',
    value: 'AR',
    addressRegexPattern: /\b(Arkansas|AR)\b/gi
  }, {
    name: 'California',
    value: 'CA',
    addressRegexPattern: /\b(California|CA)\b/gi
  }, {
    name: 'Colorado',
    value: 'CO',
    addressRegexPattern: /\b(Colorado|CO)\b/gi
  }, {
    name: 'Connecticut',
    value: 'CT',
    addressRegexPattern: /\b(Connecticut|CT)\b/gi
  }, {
    name: 'Delaware',
    value: 'DE',
    addressRegexPattern: /\b(Delaware|DE)\b/gi
  }, {
    name: 'District Of Columbia',
    value: 'DC',
    addressRegexPattern: /\b(District of Columbia|DC)\b/gi
  }, {
    name: 'Florida',
    value: 'FL',
    addressRegexPattern: /\b(Florida|FL)\b/gi
  }, {
    name: 'Georgia',
    value: 'GA',
    addressRegexPattern: /\b(Georgia|GA)\b/gi
  }, {
    name: 'Hawaii',
    value: 'HI',
    addressRegexPattern: /\b(Hawaii|HI)\b/gi
  }, {
    name: 'Idaho',
    value: 'ID',
    addressRegexPattern: /\b(Idaho|ID)\b/gi
  }, {
    name: 'Illinois',
    value: 'IL',
    addressRegexPattern: /\b(Illinois|IL)\b/gi
  }, {
    name: 'Indiana',
    value: 'IN',
    addressRegexPattern: /\b(Indiana|IN)\b/gi
  }, {
    name: 'Iowa',
    value: 'IA',
    addressRegexPattern: /\b(Iowa|IA)\b/gi
  }, {
    name: 'Kansas',
    value: 'KS',
    addressRegexPattern: /\b(Kansas|KS)\b/gi
  }, {
    name: 'Kentucky',
    value: 'KY',
    addressRegexPattern: /\b(Kentucky|KY)\b/gi
  }, {
    name: 'Louisiana',
    value: 'LA',
    addressRegexPattern: /\b(Louisiana|LA)\b/gi
  }, {
    name: 'Maine',
    value: 'ME',
    addressRegexPattern: /\b(Maine|ME)\b/gi
  }, {
    name: 'Maryland',
    value: 'MD',
    addressRegexPattern: /\b(Maryland|MD)\b/gi
  }, {
    name: 'Massachusetts',
    value: 'MA',
    addressRegexPattern: /\b(Massachusetts|MA)\b/gi
  }, {
    name: 'Michigan',
    value: 'MI',
    addressRegexPattern: /\b(Michigan|MI)\b/gi
  }, {
    name: 'Minnesota',
    value: 'MN',
    addressRegexPattern: /\b(Minnesota|MN)\b/gi
  }, {
    name: 'Mississippi',
    value: 'MS',
    addressRegexPattern: /\b(Mississippi|MS)\b/gi
  }, {
    name: 'Missouri',
    value: 'MO',
    addressRegexPattern: /\b(Missouri|MO)\b/gi
  }, {
    name: 'Montana',
    value: 'MT',
    addressRegexPattern: /\b(Montana|MT)\b/gi
  }, {
    name: 'Nebraska',
    value: 'NE',
    addressRegexPattern: /\b(Nebraska|NE)\b/gi
  }, {
    name: 'Nevada',
    value: 'NV',
    addressRegexPattern: /\b(Nevada|NV)\b/gi
  }, {
    name: 'New Hampshire',
    value: 'NH',
    addressRegexPattern: /\b(New Hampshire|NH)\b/gi
  }, {
    name: 'New Jersey',
    value: 'NJ',
    addressRegexPattern: /\b(New Jersey|NJ)\b/gi
  }, {
    name: 'New Mexico',
    value: 'NM',
    addressRegexPattern: /\b(New Mexico|NM)\b/gi
  }, {
    name: 'New York',
    value: 'NY',
    addressRegexPattern: /\b(New York|NY)\b/gi
  }, {
    name: 'North Carolina',
    value: 'NC',
    addressRegexPattern: /\b(North Carolina|NC)\b/gi
  }, {
    name: 'North Dakota',
    value: 'ND',
    addressRegexPattern: /\b(North Dakota|ND)\b/gi
  }, {
    name: 'Ohio',
    value: 'OH',
    addressRegexPattern: /\b(Ohio|OH)\b/gi
  }, {
    name: 'Oklahoma',
    value: 'OK',
    addressRegexPattern: /\b(Oklahoma|OK)\b/gi
  }, {
    name: 'Oregon',
    value: 'OR',
    addressRegexPattern: /\b(Oregon|OR)\b/gi
  }, {
    name: 'Pennsylvania',
    value: 'PA',
    addressRegexPattern: /\b(Pennsylvania|PA)\b/gi
  }, {
    name: 'Rhode Island',
    value: 'RI',
    addressRegexPattern: /\b(Rhode Island|RI)\b/gi
  }, {
    name: 'South Carolina',
    value: 'SC',
    addressRegexPattern: /\b(South Carolina|SC)\b/gi
  }, {
    name: 'South Dakota',
    value: 'SD',
    addressRegexPattern: /\b(South Dakota|SD)\b/gi
  }, {
    name: 'Tennessee',
    value: 'TN',
    addressRegexPattern: /\b(Tennessee|TN)\b/gi
  }, {
    name: 'Texas',
    value: 'TX',
    addressRegexPattern: /\b(Texas|TX)\b/gi
  }, {
    name: 'Utah',
    value: 'UT',
    addressRegexPattern: /\b(Utah|UT)\b/gi
  }, {
    name: 'Vermont',
    value: 'VT',
    addressRegexPattern: /\b(Vermont|VT)\b/gi
  }, {
    name: 'Virginia',
    value: 'VA',
    addressRegexPattern: /\b(Virginia|VA)\b/gi
  }, {
    name: 'Washington',
    value: 'WA',
    addressRegexPattern: /\b(Washington|WA)\b/gi
  }, {
    name: 'West Virginia',
    value: 'WV',
    addressRegexPattern: /\b(West Virginia|WV)\b/gi
  }, {
    name: 'Wisconsin',
    value: 'WI',
    addressRegexPattern: /\b(Wisconsin|WI)\b/gi
  }, {
    name: 'Wyoming',
    value: 'WY',
    addressRegexPattern: /\b(Wyoming|WY)\b/gi
  }]
}];
export default {
  KEYSTREAM_ACTIVATED,
  SALE_NAMES,
  SALE_TYPES,
  SALE_TYPE_NAMES,
  VEHICLE_SALE_STATES,
  COUNTRIES,
  VEHICLE_PAIRED_TO
};